<template>
  <b-container v-if="showForm">
    <b-row v-if="cartorioList.length > 0"
           no-gutters
           class="justify-content-center">
      <div class="form-inline">
        <div class="form-group mr-1">
          <label class="sr-only"
                 for="cartorioId">Selecione um cartório para continuar</label>
          <select id="cartorioId"
                  v-model="userId"
                  class="custom-select custom-select-sm"
                  name="userId">
            <option :value="null">
              Selecione um cartório para continuar
            </option>
            <option v-for="cartorio in cartorioList"
                    :key="cartorio.user_id"
                    :value="cartorio.user_id">
              {{ cartorio.cartorio_id }} - {{ cartorio.cns }} - {{ cartorio.nome }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <button :disabled="!userId"
                  class="btn btn-sm btn-primary"
                  @click="selecionarCartorio">
            Acessar
          </button>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
  import NProgress from '@/utils/progress'
  import { acessarCartorio } from "@/helpers/usuario"

  /* services */
  import CartorioService from '@/services/CartorioService'
  import UsuarioService from "@/services/Auth/UsuarioService"

  /* outros */
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        cartorioList: [],
        cartorioObj: null,
        userId: null,
        showForm: false
      }
    },
    computed: {
      ...mapGetters({
        lastPath: 'auth/getLastPath',
      }),
    },
    async mounted () {
      NProgress.start()

      // buscamos todos usuarios com o mesmo cpf logado.
      const myUsers = await UsuarioService.getMyUsers().then(resp => resp.data)

      // buscamos todos cartorios no rei
      const cartorios = await CartorioService.getCartoriosRei().then(resp => resp.data)

      this.cartorioList = []

      for (const myUser of myUsers) {
        const cartorio = cartorios.find(item => item.cartorio_id === myUser.cartorio_id)

        if (cartorio) {
          this.cartorioList.push({
            ...cartorio,
            user_id: myUser.user_id
          })
        }
      }

      // se voltar mais de um cartorio, listamos pro usuário selecionar qual login vai usar.
      if (this.cartorioList.length === 1) {
        this.userId = this.cartorioList[0].user_id
        await this.selecionarCartorio()
      } else {
        this.showForm = true
      }
    },
    methods: {
      async selecionarCartorio () {
        this.showForm = false

        NProgress.start()
        try {
          await acessarCartorio(this.cartorioList, this.userId)

          const redirectUrl = this.lastPath

          if (!redirectUrl) {
            this.$router.push({ name: 'rei_dashboard' })
          } else {
            this.$router.push(redirectUrl)
            this.$store.dispatch('auth/setLastPath', null)
          }
        } catch (e) {
          const { message } = getErrors(e)
          displayMessage('error', 'Erro', message)
          return this.$store.dispatch('auth/logout').then(() => this.$router.push({ name: 'login' }))
        }
      }
    }
  }
</script>
